import Vue from "vue";

/**
 * Mutations for clients
 */
export const mutations = {
  /**
   * Setting the value of edit client id
   *
   * @param {Object} state
   * @param {Number} value
   */
  setEditClientId(state, value) {
    state.editClientId = value;
  },

  /**
   * Setting the value of weather data is being loaded
   *
   * @param {Object} state
   * @param {Boolean} value
   */
  setLoading(state, value) {
    state.loading = value;
  },

  /**
   * Set the mode of add appointment. By default it is add
   *
   * @param {Object} state
   * @param {String} value
   */
  setMode(state, value) {
    state.mode = value;
  },

  /**
   * Clear state when logging out
   *
   * @param {Object} state
   */
  clearState(state) {
    state.dataLoaded = {};
    state.loading = false;
    state.clients = {};
    state.active = true;
    state.mode = "ADD";
    state.editClientId = 0;
  },

  /**
   * Clear add client state
   *
   * @param {Object} state
   */
  clearAddClients(state) {
    state.active = true;
    state.mode = "ADD";
    state.editClientId = 0;
  },

  /**
   * Setting the value of active to true or false to change what the clients are filtered by
   *
   * @param {Object} state
   * @param {Boolean} value
   */
  setActive(state, value) {
    state.active = value;
  },

  /**
   * Setting the clients loaded for that user to be true
   *
   * @param {Object} state
   * @param {Object} param1
   */
  setDataLoaded(state, { providerId, value }) {
    // Step 1: Checking if provider id is a number
    if (isNaN(providerId)) {
      return false;
    }

    // Step 2: If provider id is number, set the dataloaded for that provider to the value
    Vue.set(state.dataLoaded, parseInt(providerId), value);
  },

  /**
   * Setting the client array from which the data is to be displayed
   *
   * @param {Object} state
   * @param {Object} param1
   */
  setClients(state, { providerId, value }) {
    // Step 1: Checking if provider id is a number
    if (isNaN(providerId)) {
      return false;
    }

    if (parseInt(providerId) in state.clients) {
      // Step 1: Clients by combining old and new clients
      let clients = [...state.clients[parseInt(providerId)], ...value];

      // Step 3: Filter duplicate results
      let clientDistinctId = [];
      clients = clients.filter(client => {
        if (clientDistinctId.indexOf(client.id) === -1) {
          clientDistinctId.push(client.id);
          return true;
        } else {
          return false;
        }
      });

      // Step 4: Sorting client list
      clients.sort((a, b) => {
        return a["firstName"] < b["firstName"] || a["lastName"] < b["lastName"];
      });

      // Step 5: Setting the clients
      Vue.set(state.clients, parseInt(providerId), clients);
    } else {
      // Step 2: Set the clients for that provider to the value
      Vue.set(state.clients, parseInt(providerId), value);
    }
  },

  /**
   * Add the phone number which was inserted
   *
   * @param {Object} state
   * @param {Object} param1
   */
  appendPhone(state, { phone, number, selectedProviderId, clientId }) {
    if (
      selectedProviderId in state.clients &&
      state.clients[selectedProviderId].length > 0
    ) {
      const index = state.clients[selectedProviderId].findIndex(client => {
        return client.id === clientId;
      });

      const newClients = [...state.clients[selectedProviderId]];
      newClients[index][phone] = number;

      Vue.set(state.clients, selectedProviderId, newClients);
    }
  },

  /**
   * Add or remove the favourite id of an user
   *
   * @param {Object} state
   * @param {Object} param1
   */
  addOrRemoveFavourites(state, { user, res, addOrRemove }) {
    // Step 1: Data sanitization
    const providerId = isNaN(user.provider) ? false : parseInt(user.provider);
    if (!providerId) {
      return false;
    }

    // Step 2: Check if provider id is there
    const userList = { ...state.clients };
    if (!(providerId in userList)) {
      return false;
    }

    // Step 3: Update the list
    userList[providerId] = userList[providerId].map(curUser => {
      if (curUser.id === user.id) {
        if (addOrRemove === "ADD") {
          curUser.favourite_id = res.favourite.id;
        } else {
          curUser.favourite_id = 0;
        }
      }
      return curUser;
    });

    // Step 4: Update the list
    state.clients = userList;
  },

  /**
   * Add selected phone of an user
   *
   * @param {Object} state
   * @param {Object} user
   */
  addSelectedPhone(state, user) {
    // Step 1: Data sanitization
    const providerId = isNaN(user.provider) ? false : parseInt(user.provider);
    if (!providerId) {
      return false;
    }

    // Step 2: Check if provider id is there
    const userList = { ...state.clients };
    if (!(providerId in userList)) {
      return false;
    }

    // Step 3: Update the list
    userList[providerId] = userList[providerId].map(curUser => {
      if (curUser.id === user.id) {
        curUser.selected_phone = user.phone;
      }
      return curUser;
    });

    // Step 4: Update the list
    state.clients = userList;
  },
  /**
   * Update the old client with new client for a particular provider id
   * @param {Object} state
   * @param {Object} param1
   */
  updateNewClient(state, { providerId, client }) {
    Vue.set(state.clients, providerId, client);
  },

  /**
   * This is a temporary solution to add client email address
   *
   * @param state
   * @param providerId
   * @param clientId
   * @param emailId
   */
  addClientEmail(state, { providerId, clientId, emailId}) {
    const clientIndex = state.clients[providerId].findIndex(client => {
      return client.id === clientId;
    });

    state.clients[providerId][clientIndex].email1 = emailId;
  }
};
